import isGHMC, {
  getFirstDateOfMonth,
  getCurrentDate,
  formattedDate,
  formatDateTimeWithoutSec,
  getCurrentDateTime,
  formatDate
} from "../../../../Common/helper/helpar";
import { Formik, Form, Field } from "formik";
import { useEffect, useState } from "react";
import MSWManagementSecondaryCollectionStore from "./store/MSWManagementSecondaryCollectionStore";
import { MSWManagementVehiclesMonthlySecondaryExport } from "./MSWManagementMonthlySecondartExport";

export const MSWManagementMonthlyFilter = () => {
  const { fetchMSWManagementMonthlySecondaryCollectionReport } =
    MSWManagementSecondaryCollectionStore();

  const isProd = isGHMC();
  const currentDateTime = getCurrentDateTime(); // For heading timestamp
  const todayDate = getCurrentDate(); // Default ToDate for date input

  // Default filter values
  const defaultFilterValues = {
    FromDate: getFirstDateOfMonth(),
    ToDate: todayDate,
  };

  // ===================== Initialize heading dates =====================
  const [selectedDates, setSelectedDates] = useState(() => {
    const storedFilter = localStorage.getItem("MSWMonthlyFilter");
    if (storedFilter) {
      const parsed = JSON.parse(storedFilter);
      return {
        fromDate: parsed.fromDate || defaultFilterValues.FromDate,
        toDate: parsed.toDate || defaultFilterValues.ToDate,
      };
    }
    return { ...defaultFilterValues };
  });

  // ===================== Load default / stored data =====================
  useEffect(() => {
    const storedFilter = localStorage.getItem("MSWMonthlyFilter");
    if (storedFilter) {
      const parsed = JSON.parse(storedFilter);
      fetchMSWManagementMonthlySecondaryCollectionReport({
        FromDate: parsed.fromDate || defaultFilterValues.FromDate,
        ToDate: parsed.toDate || defaultFilterValues.ToDate,
      });
    } else {
      fetchMSWManagementMonthlySecondaryCollectionReport(defaultFilterValues);
    }
  }, []);

  // ===================== Handle filter submission =====================
  const handleSubmit = (values) => {
    const from = values.FromDate;
    const to = values.ToDate || todayDate;

    // Save filter
    localStorage.setItem(
      "MSWMonthlyFilter",
      JSON.stringify({ fromDate: from, toDate: to })
    );

    // Update heading
    setSelectedDates({ fromDate: from, toDate: to });

    // Fetch data
    fetchMSWManagementMonthlySecondaryCollectionReport(values);
  };

  // ===================== Utility: get 30 days before ToDate =====================
  const getLast30DaysDate = (day) => {
    const toDate = new Date(day);
    const thirtyDaysAgo = new Date(toDate.setDate(toDate.getDate() - 30));
    return thirtyDaysAgo.toISOString().split("T")[0];
  };


  return (
    <>
      {/* ===================== Heading ===================== */}
      <div className="top-header">
        <span>
          Monthly Report - MSW Management Vehicles on the Road - Secondary Collection{" "}
          ({formattedDate(selectedDates.fromDate || selectedDates.FromDate)} to {formattedDate(selectedDates.toDate || selectedDates.ToDate)}){" "}
          at ({formatDateTimeWithoutSec(currentDateTime)})
        </span>
      </div>

      {/* ===================== Filter Form ===================== */}
      <Formik
        enableReinitialize={true}
        initialValues={defaultFilterValues}
        onSubmit={handleSubmit}
      >
        {({ values }) => (
          <Form>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div className="d-flex align-items-end gap-2 mb-2">
                {/* From Date */}
                <div style={{ width: "200px" }}>
                  <div className="form-group-filter">
                    <label className="form-label w-100 text-left">From Date</label>
                    <Field
                      type="date"
                      id="FromDate"
                      name="FromDate"
                      value={values.FromDate}
                      className="form-control bg-white"
                      min={values.ToDate && getLast30DaysDate(values.ToDate)}
                      max={values.ToDate || todayDate}
                      required
                    />
                  </div>
                </div>

                {/* To Date */}
                <div style={{ width: "200px" }}>
                  <div className="form-group-filter">
                    <label className="form-label w-100 text-left">To Date</label>
                    <Field
                      type="date"
                      id="ToDate"
                      name="ToDate"
                      value={values.ToDate || todayDate}
                      className="form-control bg-white"
                      min={values.FromDate}
                      max={todayDate}
                      required
                    />
                  </div>
                </div>

                {/* Search Button */}
                <button
                  type="submit"
                  className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                >
                  Search
                </button>
              </div>

              {/* Export Button */}
              <div className="mt-4 d-flex">
                <MSWManagementVehiclesMonthlySecondaryExport
                  fromDate={values.FromDate}
                  toDate={values.ToDate || todayDate}
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
